module.exports = __webpack_public_path__ + "img/8-1-IMG_3001.7d2d42dc.png";